import { mixins, styled } from '@bob/library'
import { Link } from 'gatsby'

export const LessonMainNavigation = styled.div`
  padding: 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > a:first-child {
    ${mixins.padding.left(0)}
    & > svg:first-child {
      ${mixins.margin.right(0)}
    }
    & > svg:not(:first-child) {
      ${mixins.margin.left(-10)}
      ${mixins.margin.right(5)}
    }
  }
`

export const SideText = styled.span`
  flex: none;
  line-height: 20px;
  text-transform: uppercase;
  color: ${({ theme }: { theme: any }) => theme.colors.grayWhite};
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    ${mixins.margin.right(5)}
    ${mixins.media.min.desktop} {
      ${mixins.margin.right(30)}
    }
  }
`

export const LinkButton = styled(Link)`
  text-transform: uppercase;
  display: inline-flex;
  color: ${({ theme }: { theme: any }) => theme.colors.grayWhite};
  ${mixins.padding(10)};
  svg {
    fill: ${({ theme }: { theme: any }) => theme.colors.grayWhite};
  }
`

export const EmptySpace = styled.div<{ size: number }>`
  width: ${({ size }: { size: number }) => `${size}px`};
  height: ${({ size }: { size: number }) => `${size}px`};
  display: inline-block;
`
